import { NavLink, Outlet } from 'react-router-dom'
import { AlertTriangle, Bell, Calendar, DollarSign, ListChecks, ScrollText, Timer, Truck, Workflow } from 'lucide-react'
import { cn } from '@/lib/cn'

const tabs = [
  { to: 'capacity', label: 'Capacity', icon: Calendar },
  { to: 'delivery', label: 'Delivery', icon: Truck },
  { to: 'pricing', label: 'Pricing & Tiers', icon: DollarSign },
  { to: 'sla', label: 'SLA', icon: Timer },
  { to: 'flows', label: 'Production Flows', icon: Workflow },
  { to: 'issue-reasons', label: 'Issue Reasons', icon: AlertTriangle },
  { to: 'checklist', label: 'Checklist', icon: ListChecks },
  { to: 'notifications', label: 'Notifications', icon: Bell },
  { to: 'invoice', label: 'Invoice', icon: ScrollText },
]

/**
 * Shell for the admin configuration pages - a Settings title, a sub-nav card
 * on the left and the active page in the outlet. Below lg the sub-nav becomes
 * a horizontal tab row above the content.
 */
export default function SettingsLayout() {
  return (
    <div>
      <h1 className="mb-5 text-lg font-medium text-foreground">Settings</h1>

      <div className="items-start gap-6 lg:grid lg:grid-cols-[240px_1fr]">
        {/* Positioning lives on this wrapper - .box forces its own position (see index.css gotcha) */}
        <div className="mb-6 lg:sticky lg:top-6 lg:mb-0">
          <nav aria-label="Settings" className="box px-3 py-4">
            <p className="mb-2 ml-3 text-xs uppercase tracking-wider text-foreground/50">Settings</p>
            <div className="flex gap-1 overflow-x-auto lg:flex-col lg:overflow-visible">
              {tabs.map(({ to, label, icon: Icon }) => (
                <NavLink
                  key={to}
                  to={to}
                  className={({ isActive }) =>
                    cn(
                      'flex shrink-0 items-center gap-2.5 whitespace-nowrap rounded-lg px-3 py-2 text-sm transition-colors',
                      isActive
                        ? 'bg-primary/10 font-medium text-primary'
                        : 'text-foreground/70 hover:bg-foreground/5 hover:text-foreground',
                    )
                  }
                >
                  <Icon className="size-4" />
                  {label}
                </NavLink>
              ))}
            </div>
          </nav>
        </div>

        <div className="min-w-0">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
